
import './App.css';
import React from 'react';
import { Route, Routes,BrowserRouter } from 'react-router-dom';
import Add from './componants/add';
import Display from './componants/Display';
import Controls from './componants/Controls';
import Home from './componants/Home';
import Error from './componants/Error';
import Doctors from './componants/Doctors';
import SignIn from './componants/SignIn';
import { AuthProvider } from './contextApi/Auth_context';
import Protected from './Protected';
function App() {
return (
//   <BrowserRouter>
//    <AuthProvider>
//   <Routes>
 
//     <Route path='/login' element={<SignIn/>}></Route>
//   <Route path="/" element={<Home/>}/>
//  <Prodected>
//   <Route path="/add" element={<AddPatientForm/>}/>
//   <Route path="/display" element={<Display/>}/>
//   <Route path="/controls" element={<Controls/>}/>
//   <Route path="/doctors" element={<Doctors/>}/>
//   </Prodected>
//   <Route path='*' element={<Error/>}/>

 
//   </Routes>
//   </AuthProvider>
//   </BrowserRouter>
<BrowserRouter>
  <AuthProvider>
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<SignIn />} />
      <Route path="/" element={<Home />} />
      <Route path="*" element={<Error />} />

      {/* Protected Routes */}
      <Route
        path="/add"
        element={
          <Protected>
            <Add/>
          </Protected>
        }
      />
      <Route
        path="/display"
        element={
          <Protected>
            <Display />
          </Protected>
        }
      />
      <Route
        path="/controls"
        element={
          <Protected>
            <Controls />
          </Protected>
        }
      />
      <Route
        path="/doctors"
        element={
          <Protected>
            <Doctors />
          </Protected>
        }
      />
    </Routes>
  </AuthProvider>
</BrowserRouter>

)
}

export default App;
